<div class="design-huddle-editor-container">
  <!-- Editor Header -->
  <div class="editor-header" *ngIf="showSaveButton">
    <div class="editor-actions">
      <button
        mat-raised-button
        color="primary"
        (click)="saveDesign()"
        [disabled]="!isEditorLoaded || isSaving"
        class="save-btn">
        <mat-icon *ngIf="!isSaving">save</mat-icon>
        <mat-icon *ngIf="isSaving" class="spinning">refresh</mat-icon>
        {{ isSaving ? 'Saving...' : 'Save Design' }}
      </button>

      <button
        mat-raised-button
        color="accent"
        (click)="publishDesign()"
        [disabled]="!isEditorLoaded || isSaving"
        class="publish-btn">
        <mat-icon>publish</mat-icon>
        Publish
      </button>

      <button
        mat-raised-button
        (click)="exportDesign()"
        [disabled]="!isEditorLoaded || isSaving"
        class="export-btn">
        <mat-icon>download</mat-icon>
        Export
      </button>

      <button
        mat-button
        (click)="closeEditor()"
        class="close-btn">
        <mat-icon>close</mat-icon>
        Close
      </button>
    </div>
  </div>

  <!-- Editor Iframe -->
  <div class="editor-iframe-wrapper">
    <div class="editor-loading" *ngIf="!isEditorLoaded">
      <mat-spinner></mat-spinner>
      <p>Loading Design Huddle Editor...</p>
    </div>

    <iframe
      #editorIframe
      [src]="safeEditorUrl"
      (load)="onIframeLoad()"
      class="editor-iframe"
      [class.loaded]="isEditorLoaded"
      frameborder="0"
      allowfullscreen>
    </iframe>
  </div>
</div>
